import { Action } from '@ngrx/store';
import { RouterRequestInterface } from 'app/core/browser/models/router-request.model';

import { RouterRequestActionType } from './router-request-action-type.enum';

export class RouterRequest implements Action {
  public readonly type: RouterRequestActionType = RouterRequestActionType.RouterRequest;

  constructor(public readonly payload: RouterRequestInterface) { }
}
